import { getApiEmails } from "./RemindMeAPIServices";

export const sendEmailText = async (
  selectedEmail: string,
  textToSend: string,
  featureType: string,
  companyId: number,
  deviceId: string,

) => {
  try {
    const response = await fetch(getApiEmails('send-email-text'), {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        company_id: companyId,
        to_email: selectedEmail,
        message_content: textToSend,
        feature_type: featureType,
        device_id: deviceId,
      }),
    });

    if (!response.ok) {
      throw new Error(`Failed to send email. Server responded with ${response.status}`);
    }

    const responseData = await response.json();


    return responseData;
  } catch (error) {
    throw error;
  }
};


